import { init as initTestimonials } from './testimonials';
import { init as initCarousel } from '../theme/carousel';
const logErrors = function(err) {
    console.error(err);
};
initTestimonials().catch(logErrors);
initCarousel().catch(logErrors);
